<i18n lang="yaml" locale="en">
  rename modal: Rename modal
  name: Name
  background color: Background color
  font: Font
  add font long: Add a font by dropping it here.
  add font short: Add as font.
</i18n>

<i18n lang="yaml" locale="de">
  rename modal: Modal umbenennen
  name: Name
  background color: Hintergrundfarbe
  font: Schriftart
  add font long: Fügen Sie eine Schriftart hinzu, indem Sie sie hier ablegen.
  add font short: Als Schriftart hinzufügen.
</i18n>

<template>
  <div
    :class="modalClasses"
    :style="modalStyle"
  >
    <grid
      class="modal-content"
      :width="width"
      :height="height"
      :format="$project.format"
    >
      <component
        v-for="child in children"
        :key="child.getters.path"
        :path="child.getters.path"
        :is="child.getters.type"
        v-bind="child.getters.props"
      />
    </grid>
    <div
      id="modal-close"
      @click="closeFunc()"
    >
      <close
        color="secondary"
        size="xs"
      />
    </div>
  </div>
</template>

<script>
import Close from '@/components/icons/Close'
import Grid from '@/components/modules/Grid'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'
import fontHandler from '@/mixins/fontHandler'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'modal',
  extends: BaseModule,
  customStore: translatable,
  components: {
    Close,
    Grid
  },
  mixins: [fontHandler([
    'font'
  ])],
  inject: ['$project'],
  props: {
    closeFunc: {
      type: Function,
      required: true
    },
    // eslint-disable-next-line
    _headlineRenameModal: {
      input: 'heading',
      label: 'rename modal'
    },
    title: {
      type: String,
      required: true,
      input: 'text',
      label: 'name'
    },
    // eslint-disable-next-line
    _headlineBackgroundColor: {
      input: 'heading',
      label: 'background color'
    },
    // radio color will be removed, so we dont change here
    backgroundColor: {
      type: String,
      label: 'background color',
      input: 'color',
      default: '#fff'
    },
    // eslint-disable-next-line
    _headlineFont: {
      input: 'heading',
      label: 'font'
    },
    font: {
      input: 'drop',
      type: String,
      contentType: 'font',
      placeholder: 'add font long',
      tooltip: 'add font short',
      default: ''
    }
  },
  computed: {
    width () {
      return this.$project.format === 'landscape' ? 192 : 108
    },
    height () {
      return this.$project.format === 'landscape' ? 108 : 192
    },
    modalClasses () {
      return {
        modal: true,
        [this.$project.format]: true
      }
    },
    modalStyle () {
      return {
        'background-color': this.backgroundColor,
        ...this.fontStyles.font
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#modal-close {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #000;
  line-height: 0;
  padding: 8px;
  border-radius: 50%;
  border: 1px solid #fff;
  cursor: pointer;
  transform: translateX(40%) translateY(-40%);
}

$boxes-x-landscape: 192;
$boxes-y-landscape: 108;
$mx-landscape: ((100/$boxes-x-landscape) * 1%) * 4;
$my-landscape: ((100/$boxes-y-landscape) * 1%) * 4;

$boxes-x-portrait: 108;
$boxes-y-portrait: 192;
$mx-portrait: ((100/$boxes-x-portrait) * 1%) * 4;
$my-portrait: ((100/$boxes-y-portrait) * 1%) * 4;

.modal {
  position: absolute;
  z-index: z(modal);
  box-shadow: 0 0 20px rgba($color: #000, $alpha: 0.5);

  &.landscape {
    left: $mx-landscape;
    top: $my-landscape;
    width: calc(100% - (2 * #{$mx-landscape}));
    height: calc(100% - (2 * #{$my-landscape}));
  }

  &.portrait {
    left: $mx-portrait;
    top: $my-portrait;
    width: calc(100% - (2 * #{$mx-portrait}));
    height: calc(100% - (2 * #{$my-portrait}));
  }
}
</style>
